module.exports = __webpack_public_path__ + "img/covers-06.8e05300a.png";